// import { socketIO } from '@/plugins/SocketIOPlugin'
import store from '@/store'
import { connectSocket, getSocket } from '@/plugins/SocketIOPlugin'
import { upperCaseFormatter }       from '@/plugins/UpperCaseFormatterPlugin'

export default function createSocketIOStorePlugin(token) {
  connectSocket(token)
  const socket = getSocket()
  socket.connect()
  socket.emit('get_settings')



  socket.on("connect", () => {
    console.log('A user connected')
  })



  socket.on("error", (error) => {
    // console.log('Error', error)
  })



  socket.on("connect_error", (error) => {
    console.log('Connect error: ', error)
  })



  socket.on('notifications', (data) => {
    if(data.success) {
      if(data.type == 'row created') store.dispatch('createNotification', { title: 'Done', message: `Row [ ${data.data.name} ] has been created successfully!` })
    }

    if(data.errors) {
      for(var item of data.errors) {
        if(item.type == 'unique violation') store.dispatch('createNotification', { title: 'Error', message: `Item "${upperCaseFormatter(item.path)}": ${upperCaseFormatter(item.message)}` })
      }
    }
  })



  socket.on('get_settings', (data) => {
    switch(data.model) {
      case 'User': {
        store.dispatch('setUsers', data.users)
        break
      }
      case 'Lang': {
        store.dispatch('setLangs', data.langs)
        break
      }
      case 'Geo': {
        store.dispatch('setGeos', data.geos)
        break
      }
      case 'Theme': {
        store.dispatch('setThemes', data.themes)
        break
      }
      case 'Seller': {
        store.dispatch('setSellers', data.sellers)
        break
      }
      case 'Currency': {
        store.dispatch('setCurrencies', data.currencies)
        break
      }
      case 'Site': {
        store.dispatch('setSites', data.sites)
        break
      }
      default: {
        store.dispatch('setAllSettings', data)
        break
      }
    }
  })



  socket.on('set_settings', (model) => {
    socket.emit('get_settings', model)
  })



  socket.on('update_settings', (model) => {
    socket.emit('get_settings', model)
  })
}